import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"

interface NoteTextProps {
  body: string
  /** Set where the note is cited inside other copy (banner, warning dialog, timeline). */
  quoted?: boolean
  className?: string
}

/** A note's own words. Always in italics, so they read as a note wherever they appear. */
export function NoteText({ body, quoted = false, className }: NoteTextProps) {
  const { translate } = useTranslation()
  return (
    <span className={cn("break-words whitespace-pre-wrap italic", className)}>
      {quoted && translate("MC_NOTE_QUOTE_OPEN")}
      {body}
      {quoted && translate("MC_NOTE_QUOTE_CLOSE")}
    </span>
  )
}
